// extracted by mini-css-extract-plugin
module.exports = {"demo_image":"Business_demo_image__2O7Rj","mockup3":"Business_mockup3__Lob0U","editorMockup":"Business_editorMockup__NXUK7","editorPreview":"Business_editorPreview__Jy2WY"};